import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout route for the /case-studies segment. Renders nothing of its own — it
// exists so the /case-studies index, /case-studies/$slug detail, and
// /case-studies/rss.xml routes share a parent. Per-page SEO lives in those
// child routes.
export const Route = createFileRoute("/case-studies")({
  component: Outlet,
});
